// Helper function to update image in picture element
function updatePictureImage(pictureElement, newSrc, newSrcset) {
  if (!pictureElement) return;
  
  // Update the img element
  const img = pictureElement.querySelector('img');
  if (img) {
    if (newSrc) img.setAttribute('src', newSrc);
    if (newSrcset) img.setAttribute('srcset', newSrcset);
  }
  
  // Update the source element(s) for WebP
  const sources = pictureElement.querySelectorAll('source');
  sources.forEach(source => {
    if (source.type === 'image/webp' && newSrcset) {
      // Convert srcset to WebP format using Shopify's image transformation
      const webpSrcset = newSrcset.split(',').map(item => {
        const [url, size] = item.trim().split(' ');
        // Check if this is already a Shopify transformed URL
        if (url.includes('?') && url.includes('width=')) {
          // Add format=webp to existing parameters
          const webpUrl = url.includes('format=') 
            ? url.replace(/format=[^&]*/, 'format=webp')
            : url + '&format=webp';
          return `${webpUrl} ${size}`;
        } else {
          // For non-transformed URLs, we need to construct proper Shopify URLs
          // Extract width from size (e.g., "300w" -> "300")
          const width = size ? size.replace('w', '') : '';
          if (width) {
            const webpUrl = url + '?width=' + width + '&format=webp';
            return `${webpUrl} ${size}`;
          } else {
            // Fallback: just add format=webp
            const webpUrl = url + '?format=webp';
            return `${webpUrl} ${size || ''}`.trim();
          }
        }
      }).join(', ');
      source.setAttribute('srcset', webpSrcset);
    }
  });
}

// Helper function to get picture element for an image
function getPictureElement(img) {
  return img ? img.closest('picture') : null;
}

document.addEventListener('click', function(e) {
  if (!(e.target instanceof Element)) return;
  // Handle swatch click (label or input)
  const label = e.target.closest('label.ProductCard--ColorSwatch');
  if (!label) return;
  const input = label.querySelector('input.product-card-robot-swatch-input');
  if (!input) return;

  // Only handle if inside a swatch fieldset
  const fieldset = label.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;

  // Find the main and secondary image elements
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;

  // Get picture elements
  const mainPicture = getPictureElement(mainImage);
  const secondaryPicture = getPictureElement(secondaryImage);

  // Store original src/srcset/href if not already
  if (!fieldset._originalSrc) {
    fieldset._originalSrc = mainImage.getAttribute('src');
    fieldset._originalSrcset = mainImage.getAttribute('srcset');
    if (mainPicture) {
      const mainSource = mainPicture.querySelector('source');
      if (mainSource) {
        fieldset._originalWebpSrcset = mainSource.getAttribute('srcset');
      }
    }
    if (secondaryImage) {
      fieldset._originalSecondarySrc = secondaryImage.getAttribute('src');
      fieldset._originalSecondarySrcset = secondaryImage.getAttribute('srcset');
      if (secondaryPicture) {
        const secondarySource = secondaryPicture.querySelector('source');
        if (secondarySource) {
          fieldset._originalSecondaryWebpSrcset = secondarySource.getAttribute('srcset');
        }
      }
    }
    if (mediaLink) {
      fieldset._originalMediaHref = mediaLink.getAttribute('href');
    }
  }

  // If already checked, do nothing
  if (input.checked) return;

  // Uncheck all, check this one
  fieldset.querySelectorAll('.product-card-robot-swatch-input').forEach(function(i) {
    i.checked = false;
  });
  input.checked = true;

  // Update main image
  const newSrc = input.getAttribute('data-src');
  const newSrcset = input.getAttribute('data-srcset');
  if (mainPicture) {
    updatePictureImage(mainPicture, newSrc, newSrcset);
  } else {
    if (newSrc) mainImage.setAttribute('src', newSrc);
    if (newSrcset) mainImage.setAttribute('srcset', newSrcset);
  }

  // Update secondary image if present
  if (secondaryImage) {
    const newSecondarySrc = input.getAttribute('data-secondary-src');
    const newSecondarySrcset = input.getAttribute('data-secondary-srcset');
    if (secondaryPicture) {
      updatePictureImage(secondaryPicture, newSecondarySrc, newSecondarySrcset);
    } else {
      if (newSecondarySrc) secondaryImage.setAttribute('src', newSecondarySrc);
      if (newSecondarySrcset) secondaryImage.setAttribute('srcset', newSecondarySrcset);
    }
  }

  // Update product-card__media href
  if (mediaLink) {
    const newProductUrl = input.getAttribute('data-product-url');
    if (newProductUrl) mediaLink.setAttribute('href', newProductUrl);
  }

  // --- PRICE UPDATE LOGIC ---
  // Find the price-list element in the product card
  const priceList = productCard.querySelector('.price-list');
  const quickBuyModal = productCard.querySelector('.quick-buy-modal');
  const productHandle = input.getAttribute('data-product-handle');
  if (priceList) {
    
    // Read price and compare-at-price from swatch
    let price = input.getAttribute('data-price');
    let compareAt = input.getAttribute('data-compare-at-price');

    // Build markup
    let priceHtml = '';
    priceHtml += `<sale-price class="${compareAt ? 'text-on-sale' : ''} h6">`;
    priceHtml += `<span class="sr-only">Sale price</span>`;
    priceHtml += price;
    priceHtml += `</sale-price>`;
    if (compareAt) {
      priceHtml += `<compare-at-price class="line-through">`;
      priceHtml += `<span class="sr-only">Regular price</span>`;
      priceHtml += compareAt;
      priceHtml += `</compare-at-price>`;
    }
    priceList.innerHTML = priceHtml;
  }
  if (quickBuyModal && productHandle) {
    quickBuyModal.setAttribute('handle', productHandle);
  }
});

// Preview image and href on hover/focus (event delegation)
document.addEventListener('mouseenter', function(e) {
  if (!(e.target instanceof Element)) return;
  const label = e.target.closest('label.ProductCard--ColorSwatch');
  if (!label) return;
  const input = label.querySelector('input.product-card-robot-swatch-input');
  if (!input) return;
  const fieldset = label.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;

  // Get picture elements
  const mainPicture = getPictureElement(mainImage);
  const secondaryPicture = getPictureElement(secondaryImage);

  const newSrc = input.getAttribute('data-src');
  const newSrcset = input.getAttribute('data-srcset');
  if (mainPicture) {
    updatePictureImage(mainPicture, newSrc, newSrcset);
  } else {
    if (newSrc) mainImage.setAttribute('src', newSrc);
    if (newSrcset) mainImage.setAttribute('srcset', newSrcset);
  }
  
  if (secondaryImage) {
    const newSecondarySrc = input.getAttribute('data-secondary-src');
    const newSecondarySrcset = input.getAttribute('data-secondary-srcset');
    if (secondaryPicture) {
      updatePictureImage(secondaryPicture, newSecondarySrc, newSecondarySrcset);
    } else {
      if (newSecondarySrc) secondaryImage.setAttribute('src', newSecondarySrc);
      if (newSecondarySrcset) secondaryImage.setAttribute('srcset', newSecondarySrcset);
    }
  }
  
  if (mediaLink) {
    const newProductUrl = input.getAttribute('data-product-url');
    if (newProductUrl) mediaLink.setAttribute('href', newProductUrl);
  }


  // --- PRICE UPDATE LOGIC ---
  // Find the price-list element in the product card
  const priceList = productCard.querySelector('.price-list');
  const quickBuyModal = productCard.querySelector('.quick-buy-modal');
  const productHandle = input.getAttribute('data-product-handle');
  if (priceList) {
    
    // Read price and compare-at-price from swatch
    let price = input.getAttribute('data-price');
    let compareAt = input.getAttribute('data-compare-at-price');

    // Build markup
    let priceHtml = '';
    priceHtml += `<sale-price class="${compareAt ? 'text-on-sale' : ''} h6">`;
    priceHtml += `<span class="sr-only">Sale price</span>`;
    priceHtml += price;
    priceHtml += `</sale-price>`;
    if (compareAt) {
      priceHtml += `<compare-at-price class="line-through">`;
      priceHtml += `<span class="sr-only">Regular price</span>`;
      priceHtml += compareAt;
      priceHtml += `</compare-at-price>`;
    }
    priceList.innerHTML = priceHtml;
  }
  if (quickBuyModal && productHandle) {
    quickBuyModal.setAttribute('handle', productHandle);
  }
}, true);

document.addEventListener('focusin', function(e) {
  if (!(e.target instanceof Element)) return;
  const input = e.target;
  if (!input.classList.contains('product-card-robot-swatch-input')) return;
  const fieldset = input.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;

  // Get picture elements
  const mainPicture = getPictureElement(mainImage);
  const secondaryPicture = getPictureElement(secondaryImage);

  const newSrc = input.getAttribute('data-src');
  const newSrcset = input.getAttribute('data-srcset');
  if (mainPicture) {
    updatePictureImage(mainPicture, newSrc, newSrcset);
  } else {
    if (newSrc) mainImage.setAttribute('src', newSrc);
    if (newSrcset) mainImage.setAttribute('srcset', newSrcset);
  }
  
  if (secondaryImage) {
    const newSecondarySrc = input.getAttribute('data-secondary-src');
    const newSecondarySrcset = input.getAttribute('data-secondary-srcset');
    if (secondaryPicture) {
      updatePictureImage(secondaryPicture, newSecondarySrc, newSecondarySrcset);
    } else {
      if (newSecondarySrc) secondaryImage.setAttribute('src', newSecondarySrc);
      if (newSecondarySrcset) secondaryImage.setAttribute('srcset', newSecondarySrcset);
    }
  }
  
  if (mediaLink) {
    const newProductUrl = input.getAttribute('data-product-url');
    if (newProductUrl) mediaLink.setAttribute('href', newProductUrl);
  }
});

// Revert to original main image on mouseleave/blur (event delegation)
function revertToOriginal(fieldset) {
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;

  // Get picture elements
  const mainPicture = getPictureElement(mainImage);
  const secondaryPicture = getPictureElement(secondaryImage);

  // Always revert to original main image (from data attributes)
  if (mainPicture) {
    const originalSrc = mainPicture.getAttribute('data-original-src');
    const originalSrcset = mainPicture.getAttribute('data-original-srcset');
    const originalWebpSrcset = mainPicture.getAttribute('data-original-webp-srcset');
    
    if (originalSrc || originalSrcset) {
      updatePictureImage(mainPicture, originalSrc, originalSrcset);
      // Update WebP source manually since updatePictureImage may not handle data attribute WebP correctly
      if (originalWebpSrcset) {
        const mainSource = mainPicture.querySelector('source[type="image/webp"]');
        if (mainSource) mainSource.setAttribute('srcset', originalWebpSrcset);
      }
    }
  } else {
    // Fallback to stored original values if no data attributes
    if (fieldset._originalSrc) mainImage.setAttribute('src', fieldset._originalSrc);
    if (fieldset._originalSrcset) mainImage.setAttribute('srcset', fieldset._originalSrcset);
  }
  
  // Revert secondary image
  if (secondaryImage && secondaryPicture) {
    const originalSecondarySrc = secondaryPicture.getAttribute('data-original-secondary-src');
    const originalSecondarySrcset = secondaryPicture.getAttribute('data-original-secondary-srcset');
    const originalSecondaryWebpSrcset = secondaryPicture.getAttribute('data-original-secondary-webp-srcset');
    
    if (originalSecondarySrc || originalSecondarySrcset) {
      updatePictureImage(secondaryPicture, originalSecondarySrc, originalSecondarySrcset);
      // Update WebP source manually
      if (originalSecondaryWebpSrcset) {
        const secondarySource = secondaryPicture.querySelector('source[type="image/webp"]');
        if (secondarySource) secondarySource.setAttribute('srcset', originalSecondaryWebpSrcset);
      }
    }
  } else if (secondaryImage) {
    // Fallback to stored original values
    if (fieldset._originalSecondarySrc) secondaryImage.setAttribute('src', fieldset._originalSecondarySrc);
    if (fieldset._originalSecondarySrcset) secondaryImage.setAttribute('srcset', fieldset._originalSecondarySrcset);
  }
  
  // Revert media link
  if (mediaLink && mainPicture) {
    const originalHref = mainPicture.getAttribute('data-original-href');
    if (originalHref) {
      mediaLink.setAttribute('href', originalHref);
    }
  } else if (mediaLink && fieldset._originalMediaHref) {
    // Fallback to stored original href
    mediaLink.setAttribute('href', fieldset._originalMediaHref);
  }
}

document.addEventListener('mouseout', function(e) {
  if (!(e.target instanceof Element)) return;
  // Only handle if leaving a .product-card
  const productCard = e.target.closest('.product-card');
  if (!productCard) return;
  // If moving to a descendant of the same product card, do nothing
  if (e.relatedTarget instanceof Element && productCard.contains(e.relatedTarget)) return;
  // Find the swatch fieldset inside this product card
  const fieldset = productCard.querySelector('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  revertToOriginal(fieldset);
}, true);

document.addEventListener('focusout', function(e) {
  if (!(e.target instanceof Element)) return;
  const input = e.target;
  if (!input.classList.contains('product-card-robot-swatch-input')) return;
  const fieldset = input.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  revertToOriginal(fieldset);
});

// Touch-hold to show swatch scroller on product card (mobile UX)
(function() {
  let holdTimer = null;
  let lastScrollTop = 0;
  let activeWrapper = null;
  let touchMoved = false;
  let scrollerOpenedAt = null;
  let observer = null;

  // Hide all swatch scrollers
  function hideAllSwatchWrappers() {
    document.querySelectorAll('.ProductCard--ColorSwatchesFieldsetWrapper').forEach(function(wrapper) {
      wrapper.style.display = 'none';
    });
    activeWrapper = null;
  }

  document.addEventListener('touchstart', function(e) {
    console.log('[touchstart] event on', e.target);
    // Find the closest .product-card or .product-card__figure
    let card = e.target.closest('.product-card');
    if (!card) {
      console.log('[touchstart] No .product-card or .product-card__figure found');
      return;
    }
    console.log('[touchstart] Found card:', card);
    // Find the wrapper inside this card
    let wrapper = card.querySelector('.ProductCard--ColorSwatchesFieldsetWrapper') || (card.classList.contains('product-card') ? card.querySelector('.ProductCard--ColorSwatchesFieldsetWrapper') : null);
    if (!wrapper) {
      console.log('[touchstart] No .ProductCard--ColorSwatchesFieldsetWrapper found in card');
      return;
    }
    console.log('[touchstart] Found wrapper:', wrapper);
    // Prepare for hold
    lastScrollTop = document.scrollingElement.scrollTop;
    touchMoved = false;
    // Start hold timer
    holdTimer = setTimeout(function() {
      let currentScrollTop = document.scrollingElement.scrollTop;
      console.log('[holdTimer] Timer fired. touchMoved:', touchMoved, 'Scroll delta:', Math.abs(currentScrollTop - lastScrollTop));
      if (Math.abs(currentScrollTop - lastScrollTop) < 30 && !touchMoved) {
        console.log('[holdTimer] Showing wrapper (display: flex)');
        hideAllSwatchWrappers();
        wrapper.style.display = 'flex';
        activeWrapper = wrapper;
        // IntersectionObserver to hide if card is out of view
        if (observer) observer.disconnect();
        const productCard = card.classList.contains('product-card') ? card : card.closest('.product-card');
        if (productCard) {
          observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) {
                console.log('[IntersectionObserver] Card out of view, hiding wrapper');
                if (activeWrapper) activeWrapper.style.display = 'none';
                activeWrapper = null;
                if (observer) observer.disconnect();
              }
            });
          }, { threshold: 0.01 });
          observer.observe(productCard);
        }
      } else {
        console.log('[holdTimer] Not showing wrapper due to movement or scroll');
      }
    }, 250);
    console.log('[touchstart] Hold timer set');
  }, { passive: true });

  document.addEventListener('touchmove', function() {
    touchMoved = true;
    if (holdTimer) {
      clearTimeout(holdTimer);
      holdTimer = null;
      console.log('[touchmove] Hold timer cleared due to movement');
    }
  }, { passive: true });

  document.addEventListener('touchend', function(e) {
    if (holdTimer) {
      clearTimeout(holdTimer);
      holdTimer = null;
      console.log('[touchend] Hold timer cleared');
    }
    // Optionally, hide on tap outside
    if (activeWrapper && !e.target.closest('.ProductCard--ColorSwatchesFieldsetWrapper')) {
      console.log('[touchend] Hiding active wrapper');
      activeWrapper.style.display = 'none';
      activeWrapper = null;
      if (observer) observer.disconnect();
    }
  });
})();